import { BeatLoader } from "react-spinners";
import { LoaderSizeMarginProps } from "react-spinners/helpers/props";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";

interface Props extends LoaderSizeMarginProps {
  children?: React.ReactNode;
  inline?: boolean;
  size?: number;
  "aria-label"?: string;
  isCenter?: boolean;
}
function Spinner(props: Props): React.ReactElement<HTMLElement> {
  return (
    <Container
      className="spinner-wrapper"
      inline={(props.inline || "").toString()}
      isCenter={props.isCenter || false}
    >
      <BeatLoader
        color={COLORS.COMPANY}
        size={props.size || 16}
        aria-label={props["aria-label"]}
      />
      {props.children}
    </Container>
  );
}

export default Spinner;

const Container = styled.div<{ inline?: string; isCenter?: boolean }>`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 10px;
  padding-top: 50px;
  color: ${({ theme }) => theme?.COLORS?.WHITE || COLORS.WHITE};
  font-weight: 500;
  ${({ isCenter }) =>
    isCenter &&
    `
    position: fixed;
    top: 50%;
    left: 0;
    z-index: 3;
  `};

  ${({ inline }) => {
    if (inline === "true") {
      return `
        display: inline;
        padding-top: 0;
      `;
    }
  }}
`;
